import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'normalize-css';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './style/_element-variables.scss';
Vue.use(ElementUI);

import moment from 'moment'
import 'moment/locale/zh-cn'
Vue.prototype.$moment = moment;

import './filter';

import './utils/tools';

import './components/portal/globalComponents';

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
